import { createSelector } from "@reduxjs/toolkit";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMyParticipatedContestsThunk as onGetMyParticipatedContestsThunk } from "../../slices/users/thunk";
import attachment_icon from "../../assets/attachment_icon.svg";
import time_icon from "../../assets/time_icon.svg";
import { getFileUrl } from "../../utils/GetAuthUser";
import { Link } from "react-router-dom";
import { getRole } from "../../utils/GetRole";

const ArtistParticipateContestComponent = ({ artistId }) => {
  const dispatch = useDispatch();
  const fileUrl = getFileUrl();
  const role = getRole();

  const selectArtistState = (state) => state.user;
  const artistSelector = createSelector(selectArtistState, (artist) => ({
    isLoading: artist.isLoading,
    participatedContestList: artist.participatedContestList || [],
  }));

  const { participatedContestList, isLoading } = useSelector(artistSelector);

  useEffect(() => {
    dispatch(onGetMyParticipatedContestsThunk({ artist_id: artistId }));
    // console.log(participatedContestList);
  }, [dispatch, artistId]);

  return (
    <div className="w-full xl:max-[70%] flex flex-col border border-border_color rounded-[14px] p-5">
      <div className="flex flex-col items-start gap-4 xs:flex-row xs:items-center xs:justify-between">
        <span className="text-lg sm:text-[22px] text-black font-bold font-grotesk tracking-wide leading-7">
          {role == "artist" ? "Your" : ""} Contests
        </span>
        <div className="flex items-center gap-2 xs:gap-4">
          <span className="flex gap-3">
            <select
              name=""
              id=""
              className="w-[120px] xs:w-[140px] px-3 py-3 bg-transparent border text-secondary font-bold font-grotesk text-xs   border-border_color rounded-xl outline-none  focus:ring-1 focus:ring-secondary focus:border-secondary "
            >
              <option value="in-progress">In progress</option>
              <option value="completed">Completed</option>
              <option value="requested">Requested</option>
            </select>
          </span>
          <button className="border border-border_color rounded-[10px] py-3 px-5 text-xs font-bold font-grotesk text-secondary">
            View all
          </button>
        </div>
      </div>

      <div
        className="mt-4 overflow-x-auto     overflow-y-auto  scrollbar-hide"
        style={{ maxHeight: "calc(65vh - 120px)" }}
      >
        <table className="w-full min-w-[750px] ">
          <thead>
            <tr className="border-b border-border_color">
              <th className="text-[16px] tracking-wider leading-10 text-black font-bold font-grotesk px-2 py-3 text-left">
                Sr No.
              </th>
              <th className="text-[16px] tracking-wider leading-10 text-black font-bold font-grotesk px-2 py-3 text-left">
                Client Name
              </th>
              <th className="text-[16px] tracking-wider leading-10 text-black font-bold font-grotesk px-2 py-3 text-left">
                Image by Client
              </th>
              <th className="text-[16px] tracking-wider leading-10 text-black font-bold font-grotesk px-2 py-3 text-left">
                Time Left
              </th>
              <th className="text-[16px] tracking-wider leading-10 text-black font-bold font-grotesk px-2 py-3 text-left">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              Array.from({ length: 5 }).map((_, index) => (
                <tr key={index} className={(index + 1) % 2 === 0 ? "bg-[#2878870F]" : "bg-transparent"}>
                  {/* Sr No skeleton */}
                  <td className="px-3 py-3">
                    <div className={`h-7 w-7 rounded-lg animate-pulse ${ (index + 1) % 2 === 0 ? "bg-white" : "bg-gray-200" }`} />
                  </td>
                  {/* Client Name skeleton */}
                  <td className="px-2 py-3">
                    <div className="flex items-center gap-4">
                      <div className="w-7 h-7 rounded-full bg-gray-200 animate-pulse" />
                      <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
                    </div>
                  </td>
                  {/* Image by client skeleton */}
                  <td className="px-2 py-3">
                    <div className="flex items-center gap-2">
                      <div className="w-4 h-4 bg-gray-200 rounded animate-pulse" />
                      <div className="h-4 w-28 bg-gray-200 rounded animate-pulse" />
                    </div>
                  </td>
                  {/* Time Left skeleton */}
                  <td className="px-2 py-3">
                    <div className="flex items-center gap-2">
                      <div className="w-4 h-4 bg-gray-200 rounded animate-pulse" />
                      <div className="h-4 w-20 bg-gray-200 rounded animate-pulse" />
                    </div>
                  </td>
                  {/* Actions skeleton */}
                  <td className="px-2 py-3">
                    <div className="h-7 w-24 bg-gray-200 rounded animate-pulse" />
                  </td>
                </tr>
              ))
            ) : participatedContestList && participatedContestList.length > 0 ? (
              participatedContestList.map((row, index) => (
                <tr
                  key={row.idWithOutEncrypt || index}
                  className={
                    (index + 1) % 2 === 0
                      ? "bg-[#2878870F] rounded-tl-lg rounded-bl-lg"
                      : "bg-transparent"
                  }
                >
                  {/* Sr No */}
                  <td className="px-3 py-3  first:rounded-l-lg last:rounded-r-lg bg-transparent">
                    <div
                      className={`h-7 w-7 rounded-lg  flex items-center justify-center text-sm tracking-wider font-medium font-grotesk text-black   ${
                        (index + 1) % 2 === 0 ? "bg-white" : "bg-[#2878870F] "
                      }`}
                    >
                      {index + 1}
                    </div>
                  </td>

                  {/* Client Name */}
                  <td className="px-2 py-3">
                    <div className="flex items-center gap-4">
                      <div className="w-7 h-7 rounded-full overflow-hidden bg-gray-200">
                        <img
                          src={
                            row.userImage
                              ? `${fileUrl}/${row.userImage}`
                              : "/default-avatar.png"
                          }
                          alt="Client"
                          className="w-full h-full object-cover"
                          onError={(e) =>
                            (e.target.src = "/default-avatar.png")
                          }
                        />
                      </div>
                      <span className="text-sm tracking-wider font-medium font-grotesk text-black">
                        {row.userName || "Unknown"}
                      </span>
                    </div>
                  </td>

                  {/* Image by client */}
                  <td className="px-2 py-3">
                    {row.contestMedia && row.contestMedia.length > 0 ? (
                      <div className="flex items-center gap-2">
                        <img src={attachment_icon} alt="Attachment" />
                        <span className="text-sm tracking-wider font-medium font-grotesk text-black">
                          {row.contestMedia.length} Attachment(s)
                        </span>
                      </div>
                    ) : (
                      <span className="text-sm tracking-wider font-medium font-grotesk text-black">
                        No Media
                      </span>
                    )}
                  </td>

                  {/* Time Left */}
                  <td className="px-2 py-3">
                    <div className="flex items-center gap-2">
                      <img src={time_icon} alt="Time" />
                      <span className="text-sm tracking-wider font-medium font-grotesk text-black">
                        {row.timeLeft || "N/A"}
                      </span>
                    </div>
                  </td>

                  {/* Actions */}
                  <td className="px-2 py-3  first:rounded-l-lg last:rounded-r-lg bg-transparent">
                    <Link
                      to={`/${role}/contest-detail/2/${row.contest_id}`}
                      className="border border-primary bg-primary rounded-[10px] py-3 px-5 text-xs tracking-wider font-bold font-grotesk text-white"
                    >
                      View Details
                    </Link>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center py-5 text-gray-500">
                  No Contests Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ArtistParticipateContestComponent;
